import api from 'base/utils/api';
import { IRedirectMap, IRedirectMapRes } from 'base/interfacesV2/redirect-map';

/**
 * 获取页面重定向配置（兼容原 Shopify Url）
 */
export function getRedirectMap(): Promise<IRedirectMap> {
    return api.get('/web/featureConfig/getUriMapLink', {
        params: {
            name: 'shopify_new'
        }
    }).then(({ uriMapLinkList }: IRedirectMapRes) => uriMapLinkList);
}